import { wrapSvg } from '../../../util/SvgImage';

export const SearchThink = wrapSvg(
  <svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.37976 15.8702C7.25219 18.7427 11.7403 19.0148 14.9188 16.6866L19.8661 21.6339C20.3543 22.122 21.1457 22.122 21.6339 21.6339C22.122 21.1457 22.122 20.3543 21.6339 19.8661L16.6866 14.9188C19.0148 11.7403 18.7427 7.25219 15.8702 4.37976C12.6972 1.20675 7.55277 1.20675 4.37976 4.37976C1.20675 7.55277 1.20675 12.6972 4.37976 15.8702ZM6.14752 14.1025C3.95083 11.9058 3.95083 8.34422 6.14752 6.14752C8.34422 3.95083 11.9058 3.95083 14.1025 6.14752C16.2992 8.34422 16.2992 11.9058 14.1025 14.1025C11.9058 16.2992 8.34422 16.2992 6.14752 14.1025Z"
      fill="currentColor"
    />
  </svg>,
);
